import React, { useState, useRef } from "react";
import * as dayjs from "dayjs";
import * as $ from "jquery";
import { Button, Chip, Link } from "@material-ui/core";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "../langs/useTranslation";
import {
  getAlarmTemplatesApi,
  alarmTemplateDetailApi,
  getGroupDeviceList
} from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import HasPermission from "@/components/commons/HasPermission";
import Modal from "@/components/Modal";

export const AlarmTemplateListDatatable = React.forwardRef(
  (
    {
      className,
      style,
      getSearchParams,
      footer,
      children,
      onCheckAll,
      onLoaded,
      onView,
      onViewDevices,
      onEdit,
      onDisable,
      onEnable,
      onDelete
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [deviceRuleModalOpen, setDeviceRuleModalOpen] = useState(false);
    const [merchantModal, setMerchantModal] = useState(false);
    const [merchant, setMerchant] = useState({ data: [], number: 0 });
    const merchantTableRef = useRef(null);
    const [templateId, setTemplateId] = useState("");

    const columns = [
      {
        data: "id",
        type: "checkbox"
      },
      {
        data: "name",
        title: t({ defaultMessage: "报警模板名称" }),
        searchable: true
      },
      {
        data: "policies",
        title: t({ defaultMessage: "报警规则" }),
        orderable: false,
        // render: data => {
        //   return data.join(", ");
        // },
        createdCell: (td, data, row) => {
          ReactRender(
            <div
              style={{
                color: "#00AFC6",
                fontSzie: 14,
                fontWeight: "bold",
                cursor: "pointer"
              }}
              dangerouslySetInnerHTML={{ __html: data.join(", ") }}
              onClick={() => {
                setTemplateId(row.id);
                setDeviceRuleModalOpen(true);
              }}
            />,
            td
          );
        }
      },
      {
        name: "groups",
        data: row => {
          return row.groups.map(item => item.name).join(", ");
        },
        title: `${t({ defaultMessage: "门店" })}`,
        createdCell: (td, data, row) => {
          ReactRender(
            <div
              style={{
                color: "#00AFC6",
                fontSzie: 14,
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center"
              }}
              onClick={() => {
                setMerchant({
                  data: row.groups.map(item => ({
                    name: item.name,
                    id: item.id,
                    devices: item.devices_count
                  })),
                  number: row.groups.length
                });
                setMerchantModal(true);
              }}
            >
              {row.groups.length}
            </div>,
            td
          );
        }
      },
      {
        data: "notifier_count",
        title: t({ defaultMessage: "通知人数" }),
        className: "center",
        searchable: false
      },
      {
        data: "status",
        title: t({ defaultMessage: "模板状态" }),
        className: "center",
        createdCell: (td, data) => {
          ReactRender(
            <Chip
              size="small"
              color={data === 1 ? "primary" : "default"}
              label={
                data === 1
                  ? t({ defaultMessage: "启用" })
                  : t({ defaultMessage: "禁用" })
              }
            />,
            td
          );
        }
      },
      {
        data: "note",
        title: t({ defaultMessage: "注解" })
      },
      {
        data: "create_user.name",
        title: t({ defaultMessage: "创建人" })
      },
      {
        data: "created_at",
        title: t({ defaultMessage: "创建时间" }),
        searchable: false,
        render: data => {
          return dayjs(data).format("YYYY/MM/DD HH:mm");
        }
      },
      {
        data: null,
        title: t({ defaultMessage: "操作" }),
        className: "center nowrap",
        searchable: false,
        orderable: false,
        width: 220,
        createdCell: (td, data, row) => {
          ReactRender(
            <>
              <Button size="small" color="primary" onClick={() => onView(row)}>
                {t({ defaultMessage: "查看" })}
              </Button>
              <HasPermission permission="alarm_policy_edit">
                <Button
                  size="small"
                  color="primary"
                  onClick={() => onEdit(row)}
                >
                  {t({ defaultMessage: "编辑" })}
                </Button>
              </HasPermission>
              <HasPermission permission="alarm_policy_enable">
                {row.status === 1 ? (
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => onDisable(row)}
                  >
                    {t({ defaultMessage: "禁用" })}
                  </Button>
                ) : (
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => onEnable(row)}
                  >
                    {t({ defaultMessage: "启用" })}
                  </Button>
                )}
              </HasPermission>
              <HasPermission permission="alarm_policy_delete">
                <Button
                  size="small"
                  color="secondary"
                  onClick={() => onDelete(row)}
                >
                  {t({ defaultMessage: "删除" })}
                </Button>
              </HasPermission>
            </>,
            td
          );
        }
      }
    ];

    const ajax = (data, callback) => {
      return getAlarmTemplatesApi({
        ...data,
        ...getSearchParams()
      }).then(res => {
        callback({
          data: res.data,
          draw: data.draw,
          recordsFiltered: res.recordsTotal,
          recordsTotal: res.recordsTotal
        });
      });
    };

    const columns2 = [
      {
        data: "name",
        title: t({ defaultMessage: "规则名称" })
      },
      {
        data: "value",
        title: t({ defaultMessage: "值" })
      },
      {
        data: "autoReboot",
        title: t({ defaultMessage: "自动重启" }),
        createdCell: (td, data) => {
          ReactRender(
            <Chip
              size="small"
              color={data ? "primary" : "default"}
              label={
                data
                  ? t({ defaultMessage: "启用" })
                  : t({ defaultMessage: "禁用" })
              }
            />,
            td
          );
        }
      }
    ];

    const policiesAjax = (data, callback) => {
      return alarmTemplateDetailApi({ id: templateId }).then(res => {
        callback({
          data: res.detail.policies.map(v => {
            const ext = JSON.parse(v.ext || "{}");
            const policyName = v.alarm_policy_option.name;
            if (policyName === "App Crash Detection") {
              return {
                name: v.alarm_policy_option.name,
                value: ext.app,
                autoReboot: !!ext.auto_restart
              };
            }
            if (policyName === "Device Offline Monitor") {
              return {
                name: v.alarm_policy_option.name,
                value: "",
                autoReboot: false
              };
            }
            if (policyName === "Peripheral Monitor") {
              return {
                name: v.alarm_policy_option.name,
                value: ext.name,
                autoReboot: false
              };
            }
            return {
              name: v.alarm_policy_option.name,
              value: `${v.operator}${v.value}${v.alarm_policy_option.unit}`,
              autoReboot: false
            };
          })
          // draw: data.draw,
          // recordsFiltered: res.recordsTotal,
          // recordsTotal: res.recordsTotal
        });
      });
    };

    const columns3 = [
      {
        data: "id",
        width: 28,
        createdCell: (td, data, rowData, rowIndex) => {
          if (!rowData.devices) return ReactRender(<div />, td);
          ReactRender(
            <div
              onClick={e => {
                const tr = td.closest("td");
                const api = merchantTableRef.current.api();
                const row = api.row(tr);
                const $div = $(td).children().first().children().first();
                if (row.child.isShown()) {
                  $div.html("+");
                  row.child.hide();
                } else {
                  getGroupDeviceList({ groupId: rowData.id }).then(
                    ({ devices }) => {
                      $div.html("-");
                      let trs = "";
                      devices.forEach(device => {
                        trs += `
                      <tr style="border: 0">
                        <td style="width: 36px"></td>
                        <td style="width: 240px">${rowData.name}</td>
                        <td style="width: 248px">-</td>
                        <td style="width: 394px">${device.deviceName}</td>
                      </tr>
                      `;
                      });
                      row
                        .child(
                          `
                      <table style="width:100%;border-collapse: collapse;">
                      ${trs}
                      </table>
                    `
                        )
                        .show();
                      $(row.child().get(0))
                        .children()
                        .first()
                        .css({ padding: 0 });
                    }
                  );
                }
              }}
            >
              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 16,
                  height: 16,
                  border: "1px solid #A2A2A2",
                  color: "#A2A2A2"
                }}
              >
                +
              </div>
            </div>,
            td
          );
        }
      },
      {
        data: "name",
        title: t({ defaultMessage: "门店" }),
        width: 240
      },
      {
        data: "devices",
        title: t({ defaultMessage: "设备数量" }),
        width: 248
      },
      {
        title: t({ defaultMessage: "设备名称" }),
        render: () => "-",
        width: 394
      }
    ];

    return (
      <>
        <Modal
          onClose={() => setDeviceRuleModalOpen(false)}
          onConfirm={() => setDeviceRuleModalOpen(false)}
          showCancel={false}
          open={deviceRuleModalOpen}
          width={794}
          title={t({ defaultMessage: "设备规则" })}
          // footer={footer}
        >
          {deviceRuleModalOpen && (
            <DataTable
              options={{ serverSide: false }}
              // data={[{a: "1", b: "2"}]}
              ajax={policiesAjax}
              columns={columns2}
              paging={false}
              showCheckAll={false}
              showFooter={false}
              autoLoad
            />
          )}
        </Modal>
        <Modal
          onClose={() => setMerchantModal(false)}
          onConfirm={() => setMerchantModal(false)}
          showCancel={false}
          open={merchantModal}
          width={794}
          title={t(
            { defaultMessage: "门店数 ({num})" },
            { num: merchant.number }
          )}
          // footer={footer}
        >
          {merchantModal && (
            <DataTable
              options={{ serverSide: false }}
              data={merchant.data}
              // ajax={policiesAjax}
              columns={columns3}
              paging={false}
              showCheckAll={false}
              showFooter={false}
              autoLoad
              ref={merchantTableRef}
            />
          )}
        </Modal>
        <DataTable
          ref={ref}
          ordering
          columns={columns}
          ajax={ajax}
          className={className}
          style={style}
          footer={footer}
          scrollable
          showCheckAll={false}
          onCheckAll={onCheckAll}
          onLoaded={onLoaded}
        >
          {children}
        </DataTable>
      </>
    );
  }
);
